import moment from "moment"
import path from "path-browserify"
import { LEARN } from "path/constants"
import LibraryResourceContainer from "../LibraryResourceContainer"

const {
  loadResourcePath,
  loadResourcePathStep,
  loadResourcePathLesson
} = require("path/middleware")

// handle the case where the url is linking to a path item's ID rather than source ID
// this is possible when hitting a bookmarked url for a path item that has been back synced to source
const handleSourceItemRedirect = (nextState, replaceState) => {
  const itemId = parseInt(nextState.match.params.pathItemSourceId)
  const item = window.App.getStore("path").request.getPathItemById(itemId)

  if (item && item.get("sync_source_id") !== itemId) {
    const getItemUrl = (itemId) => {
      const itemLabel = stepId ? "step" : "lesson"
      return `/library/${nextState.match.params.resourceSlug}/${nextState.match.params.cohortId}/${nextState.match.params.section}/${itemLabel}/${itemId}/`
    }

    // get the remaining part of the pathname to append to redirect url
    const pathnameRemainder = nextState.location.pathname.slice(
      getItemUrl(itemId).length
    )
    const pathnameRedirect =
      getItemUrl(item.get("sync_source_id")) + pathnameRemainder

    // return (
    //   replaceState &&
    //   replaceState({
    //     ...nextState.location,
    //     pathname: pathnameRedirect
    //   })
    // )

    // replaceState not working, maybe due to promise
    App.navigate(pathnameRedirect)
  }
}

const onEnterStep = async (nextState, replaceState) => {
  await loadResourcePathStep(nextState, replaceState)
  const { group } = App.getStore("step").getState()
  const { mode } = App.getStore("path").getState()
  if (mode === LEARN) {
    if (
      group &&
      group.starts &&
      !group.passive_starts &&
      moment(group.starts).isAfter()
    ) {
      // lesson hasn't started yet, route to the lesson
      const lessonRoute = `/library/${nextState.match.params.resourceSlug}/${nextState.match.params.cohortId}/path/lesson/${group.sync_source_id}/`
      // replaceState not working, maybe due to promise
      App.navigate(lessonRoute)
    }
  }

  return handleSourceItemRedirect(nextState, replaceState)
}

const onEnterLesson = async (nextState, replaceState) => {
  await loadResourcePathLesson(nextState)
  return handleSourceItemRedirect(nextState, replaceState)
}

const onRouteToNotes = (nextState) =>
  loadResourcePathStep(nextState).then(() => {
    const { notes_per_target } = window.App.getStore("note").getState()
    const { step, notes } = window.App.getStore("step").getState()
    const forceReload =
      !notes ||
      notes.length !=
        (notes_per_target &&
          notes_per_target[step.sync_source_id] &&
          notes_per_target[step.sync_source_id].total_notes)
    window.App.getStore("step")
      .action.loadNotes(forceReload)
      .promise.then(() => window.App.getStore("note").action.showNotesForStep())
  })

const onLeaveNotes = () => window.App.getStore("note").action.closeNotes()

const onLeaveDiscussionRoute = (nextState) =>
  window.App.getStore("discussion").action.clearSelectedDiscussion()

const onEnterPathNotes = (nextState) =>
  loadResourcePath(nextState).then(() => {
    // Due to recent changes in routing behavior, we must first clear
    // the previously set item. Otherwise, the note store loads the notes
    // based on the current calculated context which depends on the set item.
    // We want to continue storing all notes for the path, but simply group them
    // according to the pathItemSourceId.
    window.App.getStore("note")._mutate({ item: null })

    return window.App.getStore("note")
      .action.loadNotes()
      .promise.then(() => {
        const { pathItemSourceId } = nextState.match.params
        window.App.getStore("note")
          .action.groupNotesByTarget()
          .showNotes({ view: "list", pathItemSourceId })
        return setPathNotesLaunchedFrom(nextState)
      })
  })

var setPathNotesLaunchedFrom = function (nextState) {
  const back = nextState.match.params.pathItemSourceId ? "../../" : "../"
  const launched_from = {
    pathname: path.join(nextState.location.pathname, back)
  }
  return window.App.getStore("navigation").action.setLaunchedFrom(launched_from)
}

const redirectCompletion = (nextState, replace, callback) => {
  // Redirects older completion URLs to the new format
  const { cohortId, pathItemSourceId, pathItemId } = nextState.match.params

  const search = new URLSearchParams()
  if (cohortId && !pathItemSourceId) {
    search.set("cohort_id", cohortId)
  }
  if (pathItemSourceId) {
    search.set("source_id", pathItemSourceId)
  }
  if (pathItemId) {
    search.set("pathItemId", pathItemId)
  }

  let url = `/completion/`
  if (pathItemId) {
    url = `${url}${pathItemId}/`
  }
  const redirectLocation = {
    pathname: url,
    search: `?${search.toString()}`
  }
  return callback(replace(redirectLocation))
}

const redirectFeedback = (nextState, replace, callback) => {
  // Redirects older completion URLs to the new format
  const { pathItemSourceId } = nextState.match.params
  const user_id = window.App.getStore("auth").getState().user.id
  const redirectLocation = {
    pathname: "/completion/",
    query: {
      user_id,
      source_id: pathItemSourceId
    }
  }
  return callback(replace(redirectLocation))
}

export default [
  // completion and feedback redirects
  {
    path: ":pathItemType(step)/:pathItemSourceId(\\d+)/completion/:pathItemId(\\d+)/",
    onEnter: redirectCompletion
  },
  {
    path: ":pathId(\\d+)/completion/:pathItemId(\\d+)?/",
    onEnter: redirectCompletion
  },
  {
    path: ":pathItemType(step)/:pathItemSourceId(\\d+)/feedback/",
    onEnter: redirectFeedback
  },
  // active routes
  {
    path: ":pathItemType(step)/:pathItemSourceId(\\d+)/",
    onEnter: onEnterStep,
    component: LibraryResourceContainer,
    childRoutes: [
      {
        path: "discussion/",
        onLeave: onLeaveDiscussionRoute,
        childRoutes: require("discussion/routes").default
      },
      {
        path: "notes/",
        onEnter: onRouteToNotes,
        onLeave: onLeaveNotes
      }
    ]
  },
  {
    path: ":pathItemType(lesson)/:pathItemSourceId(\\d+)/",
    component: LibraryResourceContainer,
    onEnter: onEnterLesson
  },
  {
    path: "notes/:pathItemSourceId(\\d+)?/",
    onEnter: onEnterPathNotes,
    onLeave: onLeaveNotes
  }
]
